import { render, staticRenderFns } from "./TusmoLogo.vue?vue&type=template&id=1d3f6cfe&scoped=true"
import script from "./TusmoLogo.vue?vue&type=script&lang=js"
export * from "./TusmoLogo.vue?vue&type=script&lang=js"
import style0 from "./TusmoLogo.vue?vue&type=style&index=0&id=1d3f6cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f6cfe",
  null
  
)

export default component.exports